var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8,0C12.7,0,.6,12.2.6,27.2s12.2,27.2,27.2,27.2,27.2-12.2,27.2-27.2S42.8,0,27.8,0ZM27.8,10.7c4.6,0,8.3,3.7,8.3,8.3s-3.7,8.3-8.3,8.3-8.3-3.7-8.3-8.3,3.7-8.3,8.3-8.3ZM14,43.7c0-7.7,6.1-13.8,13.8-13.8s13.8,6.1,13.8,13.8H14Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.b3102d6bf8bbec2cb3c94ef1b54e4a7b.svg";
export { ForwardRef as ReactComponent };